import { useAuth } from '../contexts';
import { isGuest } from '../utils/guestScreens';

/**
 * Is the current login a Guest (LHPH's auditors)? The screens a Guest may open hide their
 * write controls on this (lhphcapital-7xvj follow-up a).
 *
 * ⚠️ Not canRunStaffActions(): that is true for a Guest, and it also gates pages a Guest
 * may open (StaffOnlyRoute). UX only — the server refuses every Guest write (guestReadOnly.js).
 */
export const useIsGuest = (): boolean => {
  const { user } = useAuth();
  return isGuest(user);
};
